import { Button } from "../../elements/Button";
import { useJourneyPlanner } from "./JourneyPlannerContext";

function JourneyPlannerFooter() {
  const { plannerNavigation } = useJourneyPlanner();
  const {
    isDirty = false,
    onSave = null,
    saving = false,
  } = plannerNavigation || {};

  return (
    <div className="entity-page__footer d-flex justify-content-end gap-3 px-3 px-md-4">
      <Button
        text="Save"
        title={undefined}
        disabled={saving || !isDirty || !onSave}
        showSpinner={saving}
        className="entity-page__footer-btn--primary rounded-2 fw-medium"
        onClick={() => onSave && onSave()}
      />
    </div>
  );
}

export default JourneyPlannerFooter;
